import { LinkButton, type LinkButtonProps } from '@kk/ui/components/Button';
import type React from 'react';
import { twMerge } from 'tailwind-merge';

export type PromoCardProps = {
  className?: string;
  image: React.ReactNode;
  title: string;
  description: string | React.ReactNode;
  links?: LinkButtonProps[];
};

export function PromoCard(props: PromoCardProps) {
  return (
    <article
      className={twMerge(
        'bg-neutral-5 grid screen:grid-rows-[96px_1fr_auto] gap-y-10 screen:p-8 md:rounded-md',
        props.className,
      )}
    >
      <figure role="presentation" className="print:hidden">
        {props.image}
      </figure>
      <div className="flex flex-col gap-4">
        <header>
          <h2 className="typ-headline-md text-blue-100">{props.title}</h2>
        </header>
        <p className="typ-body-sm whitespace-pre-wrap max-w-[400px]">
          {props.description}
        </p>
      </div>
      {props.links ? (
        <footer className="flex flex-col gap-2 md:flex-row md:flex-wrap">
          {props.links.map((link, index) => (
            <LinkButton
              key={link.href ?? link.to ?? index}
              className={'flex align-baseline justify-center '}
              {...link}
            />
          ))}
        </footer>
      ) : null}
    </article>
  );
}

export default PromoCard;
